import { Button } from '@bfe/moly';
import { LockIcon } from '@bfe/moly-icons';
import { useNavigate } from 'react-router-dom';

import AccountBasicItem from '@/components/AccountBasicItem';
import { useI18nContext } from '@/i18n/I18n';

const ModifyPassword = () => {
  const [$t] = useI18nContext();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/app/user/security/modify-password');
  };
  return (
    <AccountBasicItem
      icon="password"
      molyIcon={<LockIcon />}
      text={$t('Login Password')}
      status={true}
      statusNode={<>{$t('Set up')}</>}
      operation={
        <>
          <Button
            size="small"
            data-radius="small"
            variant="secondary"
            onClick={handleClick}
          >
            {$t('modify')}
          </Button>
        </>
      }
    />
  );
};

export default ModifyPassword;
